import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const buttonWithAlertDialog = (props) => {
  const [showDialog, setShowDialog] = useState(false);

  const handleClickOpen = () => {
    setShowDialog(true);
  };

  const handleClose = () => {
    setShowDialog(false);
  };

  const {
    okButtonTitle,
    cancelButtonTitle,
    okButtonHandler,
    content,
    buttonTitle,
    title,
    details,
  } = props;
  return (
    <div>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
        style={{ marginBottom: 5 }}
      >
        {buttonTitle}
      </Button>
      <Dialog
        open={showDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              okButtonHandler();
              handleClose();
            }}
            color="primary"
          >
            {okButtonTitle}
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            {cancelButtonTitle}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default buttonWithAlertDialog;
